import React from "react";
import { Link } from "react-router-dom";
import exclamationMark from "./exclamation-mark.png";
import styles from "./styles.module.scss";
import { STRINGS } from "./strings";
import { PLAN_TYPES } from "constants/common";

const TrialPeriodNotification = (props) => {
  const { customerDetail, tutorialDetail, showToast, userExtraData } = props;

  const isCompanyOwner = userExtraData?.company_permissions?.company_owner;
  const isOnlinePlan = customerDetail?.plan?.plan_type === PLAN_TYPES.ONLINE;
  const hasNoPaymentMethod =
    "payment_methods" in (customerDetail ?? {}) &&
    !customerDetail.payment_methods?.length;

  const shouldShowAddCard =
    hasNoPaymentMethod && isOnlinePlan && isCompanyOwner;
  const hasTutorialDetail = !!tutorialDetail;

  return (
    <div className={`${styles["verify"]} pt-2 pl-0 w-100`}>
      <img className={styles["icon"]} src={exclamationMark} alt="Icon" />
      <span className="d-inline-block align-middle">
        {STRINGS.FREE_TRIAL_MESSAGE}{" "}
        {customerDetail.trial_end}.
      </span>
      {shouldShowAddCard && (
        <div className={styles["okay"]}>
          {hasTutorialDetail ? (
            <Link to="/vendor/payment-method">
              <span className={styles["verify-now"]}>
                {STRINGS.ADD_CARD_DETAILS}
              </span>
            </Link>
          ) : (
            <span className={styles["verify-now"]} onClick={showToast}>
              {STRINGS.ADD_CARD_DETAILS}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default TrialPeriodNotification;
